import { render, staticRenderFns } from "./FreeProducts.vue?vue&type=template&id=592623fb&"
import script from "./FreeProducts.vue?vue&type=script&lang=js&"
export * from "./FreeProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/fwgcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('592623fb')) {
      api.createRecord('592623fb', component.options)
    } else {
      api.reload('592623fb', component.options)
    }
    module.hot.accept("./FreeProducts.vue?vue&type=template&id=592623fb&", function () {
      api.rerender('592623fb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/fwgcontao/js/components/FreeProducts.vue"
export default component.exports